export default __webpack_public_path__ + "static/media/qr_chplay_okara_tl.3adefe10.svg";